import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useCountUp } from 'react-countup';

const baseURL = 'https://read-counts.yesware.com/api/reads?pageUrl=';
const baseCount = 1000;

const ReadCount = ({ slug }) => {
  const { countUp, update, reset } = useCountUp({
    duration: 1,
    end: 0,
    separator: ',',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${baseURL}${slug}`, {
          method: 'POST',
        });
        const data = await response.json();
        update(parseInt(data.Attributes.readCount.N, 10) + baseCount);
      } catch (error) {
        console.log('readCount error', error);
      }
    };
    reset();
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  return (
    <>{countUp !== '0' ? <span>{countUp} reads</span> : <span>&nbsp;</span>}</>
  );
};

ReadCount.propTypes = {
  slug: PropTypes.string.isRequired,
};

export default ReadCount;
